// @note This code is a simplified version of how Twitter handles RTL text.

const pattern =
  /[\u0600-\u06FF]|[\u0750-\u077F]|[\u0590-\u05FF]|[\uFE70-\uFEFF]/gm
const threshold = 0.3

function isRTL(str: string) {
  const rtlCharacters = str.match(pattern)
  if (rtlCharacters === null || rtlCharacters.length === 0) {
    return false
  }

  const rtlPercentage = rtlCharacters.length / str.trim().length
  return rtlPercentage > threshold
}
export default isRTL
